import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

export const simpleNumberFormatter =
  (
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    multiplier = 1,
    suffix = "",
  ) =>
  (num) => {
    num = Number(num);
    if (isNaN(num)) return "";
    num *= multiplier;
    return (
      num.toLocaleString(undefined, {
        minimumFractionDigits,
        maximumFractionDigits,
      }) + suffix
    );
  };

export const PercentageFieldView = ({ field, value }) => {
  const formattedValue = simpleNumberFormatter(2, 2, 100, " %")(value);

  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={formattedValue || ""}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    />
  );
};

export const percentageFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "number",
    valueFormatter: simpleNumberFormatter(2, 2, 100, " %"),
  };
};
